import { find, pipe, prop, propEq } from 'ramda';

export const parseConfig = ({ leaderboards = [] }) => {
    const leaderboardsCustomPages = [];

    leaderboards.forEach((leaderboard) => {
        const customLeaderboardPageProp = pipe(
            prop('customAttributes'),
            find(propEq('name', 'leaderboardPage'))
        )(leaderboard);

        const customLeaderboardPageTagProp = pipe(
            prop('customAttributes'),
            find(propEq('name', 'leaderboardTag'))
        )(leaderboard);

        const customLeaderboardPageOptionProp = pipe(
            prop('customAttributes'),
            find(propEq('name', 'leaderboardTag'))
        )(leaderboard);

        if (customLeaderboardPageProp && customLeaderboardPageProp.value) {
            leaderboardsCustomPages.push({
                leaderboardPage: customLeaderboardPageProp.value,
                leaderboardId: leaderboard.leaderboardId,
                leaderboardTag: customLeaderboardPageTagProp && customLeaderboardPageTagProp.value,
                leaderboardOption: customLeaderboardPageOptionProp && customLeaderboardPageOptionProp.value
            });
        }
    });

    return leaderboardsCustomPages;
};
